'use strict';

import navbar from '../components/layout/navbar/i18n/fr-CA';

import toolbox from '../pages/registrations/admin/components/toolbox/i18n/fr-CA';
import searchInputTranslation from '../components/library/inputs/search/i18n/fr-CA';
import headerTranslation from '../components/layout/header/i18n/fr-CA';
import userMenu from '../components/layout/header/userMenu/i18n/fr-CA';
import organizationMenu from '../components/layout/navbar/organizationMenu/i18n/fr-CA';
import errorTranslation from '../components/errors/i18n/fr-CA';
import modalComponent from '../components/modal/i18n/fr-CA';
import publicControls from '../components/form/public/controls/i18n/fr-CA';
import inputs from '../components/library/inputs/i18n/fr-CA';
import formPublic from '../components/form/public/i18n/fr-CA';
import fields from '../components/form/public/utilities/i18n/fr-CA';
import slices from '../slices/i18n/fr-CA';

/* Pages */
import formList from '../pages/registrations/i18n/fr-CA';
import formSettings from '../pages/registrations/admin/components/formSettings/i18n/fr-CA';
import rules from '../pages/registrations/admin/components/rules/i18n/fr-CA';
import adminProperties from '../pages/registrations/admin/components/properties/i18n/fr-CA';
import optionsWrapper from '../pages/registrations/admin/components/form/utilities/i18n/fr-CA';
import formAdmin from '../pages/registrations/admin/components/i18n/fr-CA';
import loginPage from '../pages/login/i18n/fr-CA';
import formConfirmPage from '../pages/registrations/confirm/i18n/fr-CA';
import organizationPage from '../pages/organization/i18n/fr-CA';
import reports from '../pages/reports/i18n/fr-CA';
import paymentAccountsPage from '../pages/paymentAccounts/i18n/fr-CA';
import paymentModes from '../pages/registrations/admin/components/paymentModes/i18n/fr-CA';
import discountCodes from '../pages/registrations/admin/components/discountCodes/i18n/fr-CA';
import userList from '../pages/users/i18n/fr-CA';
import notificationList from '../pages/notifications/i18n/fr-CA';

export default {
  cancel: 'Annuler',
  delete: 'Supprimer',
  save: 'Sauvegarder',
  confirm: 'Confirmer',
  add: 'Ajouter',
  french: 'Français',
  english: 'Anglais',
  back: 'Retour',
  ...navbar,
  ...toolbox,
  ...searchInputTranslation,
  ...headerTranslation,
  ...userMenu,
  ...organizationMenu,
  ...errorTranslation,
  ...formList,
  ...rules,
  ...publicControls,
  ...formSettings,
  ...modalComponent,
  ...inputs,
  ...adminProperties,
  ...optionsWrapper,
  ...formAdmin,
  ...loginPage,
  ...formPublic,
  ...formConfirmPage,
  ...organizationPage,
  ...reports,
  ...paymentAccountsPage,
  ...slices,
  ...fields,
  ...paymentModes,
  ...discountCodes,
  ...userList,
  ...notificationList,
};
